import { Icon, Menu } from 'antd';
import {
  isEmpty, isNaN, map, remove, toNumber
} from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from 'src/constants/ThemeSetting';
import { AuthenticationMenu } from 'src/helpers/Authorization';
import Permission from 'src/helpers/Permission';
import { getUserInfo } from 'src/util/Common';
import IntlMessages from 'src/util/IntlMessages';
import Auxiliary from 'util/Auxiliary';
import CustomScrollbars from 'util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';

const MenuItem = Menu.Item;
const { SubMenu } = Menu;
let isMounted = true;

/**
 * Set isMounted
 * @param {boolean} value
 */
const setIsMounted = (value = true) => {
  isMounted = value;
  return isMounted;
};

/**
 * Get isMounted
 */
const getIsMounted = () => isMounted;

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    const userInfo = getUserInfo(props.auth);
    const maHuyen = !isEmpty(userInfo) && userInfo.maHuyen ? userInfo.maHuyen : undefined;
    const maXa = maHuyen && userInfo.maXa ? userInfo.maXa : undefined;
    setIsMounted(true);
    this.state = {
      isCollapse: false,
      isTKCapTinh: !maHuyen,
      isCapXa: maXa
    };
  }

  /**
 * Set state properties
 * @param {object} state data cần setState
 * @param {function} callback thực thi hàm sau khi đã cập nhật state hoàn tất
 * @returns {void} gọi hàm this.setStateData để cập nhật state
 * @memberof SidebarContent
 */
  setStateData = (state, callback) => {
    if (!getIsMounted()) {
      return;
    }
    this.setState(state, callback);
  }

  getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return 'gx-no-header-notifications';
    }
    return '';
  };

  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return 'gx-no-header-submenu-popup';
    }
    return '';
  };

  changeCollapsed = (isCollapse) => {
    this.setStateData({ isCollapse });
  }

  /**
   * Thay đổi lại key menu để thiết lập active menu kể cả khi nhấn vào thêm mới chỉnh sửa
   * @params {*} list danh sách
   * @memberof SidebarContent
   */
  reSelectedKeys = (selectedKeys) => {
    const listToRemove = ['them-moi', 'chinh-sua', '', 'chi-tiet'];
    const selectedKeysTmp = selectedKeys.split('/');
    map(listToRemove, (val) => remove(selectedKeysTmp, (item) => item === val));
    // Remove all number as string in array
    remove(selectedKeysTmp, (item) => {
      // convert to number
      if (!isNaN(toNumber(item))) {
        return true;
      }
      return false;
    });
    return selectedKeysTmp.join('/');
  }

  /**
   * handleClick: Click menu xóa dataFilter
   * @memberof SidebarContent
   */
  handleClick = () => {
    localStorage.removeItem('dataFilter');
  };

  render() {
    const {
      themeType, pathname, navStyle, activedVaiTro
    } = this.props;
    const { isCollapse, isTKCapTinh, isCapXa } = this.state;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = !isCollapse
      ? ['thong-ke', 'bieu-mau-thong-ke', 'thong-ke/thong-tu-01', 'thong-ke/thong-tu-02'] : [];
    const newSelectedKeys = this.reSelectedKeys(selectedKeys);
    const nhapLieu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.NHAP_LIEU, Permission.XEM]);
    const quanLyThon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QUAN_LY_THON, Permission.XEM]);
    const quanLyXa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QUAN_LY_XA, Permission.XEM]);
    const thongKe = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.THONG_KE, Permission.XEM]);

    return (
      <Auxiliary>
        <SidebarLogo changeCollapsed={this.changeCollapsed} />
        <div className="gx-sidebar-content">
          <CustomScrollbars className="gx-layout-sider-scrollbar">
            <Menu
              className="submenu-parent"
              defaultOpenKeys={defaultOpenKeys}
              mode="inline"
              onClick={this.handleClick}
              selectedKeys={[newSelectedKeys]}
              // inlineCollapsed
              theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            >
              {/* nhập liệu */}
              {(nhapLieu)
                && (
                  <MenuItem
                    key="danh-muc/nhap-lieu"
                    className={isCollapse ? '' : 'menuItemQTI not-children'}
                    title={isCollapse ? 'Nhập liệu' : ''}
                  >
                    <Link to="/danh-muc/nhap-lieu">
                      {isCollapse ? <Icon style={{ fontSize: '18px' }} type="audit" />
                        : <><Icon type="audit" /> <IntlMessages id="sidebar.nhapLieu" /></>}
                    </Link>
                  </MenuItem>
                )}

              {/* quản lý xã */}
              {(quanLyXa)
                && (
                  <MenuItem
                    key="danh-muc/quan-ly-xa"
                    className={isCollapse ? '' : 'menuItemQTI not-children'}
                    title={isCollapse ? 'Quản lý xã' : ''}
                  >
                    <Link to="/danh-muc/quan-ly-xa">
                      {isCollapse
                        ? <Icon style={{ fontSize: '18px' }} type="apartment" />
                        : <><Icon type="apartment" /><IntlMessages id="sidebar.quanLyXa" /></>}
                    </Link>
                  </MenuItem>
                )}

              {/* quản lý thôn */}
              {(quanLyThon)
                && (
                  <MenuItem
                    key="danh-muc/quan-ly-thon"
                    className={isCollapse ? '' : 'menuItemQTI not-children'}
                    title={isCollapse ? 'Quản lý thôn' : ''}
                  >
                    <Link to="/danh-muc/quan-ly-thon">
                      {isCollapse ? <Icon style={{ fontSize: '18px' }} type="cluster" />
                        : <><Icon type="cluster" /><IntlMessages id="sidebar.quanLyThon" /></>}
                    </Link>
                  </MenuItem>
                )}

              {/* thống kê */}
              {(thongKe)
                && (
                  <SubMenu
                    key="thong-ke"
                    className={this.getNavStyleSubMenuClass(navStyle) + isCollapse && ''}
                    title={(
                      <span className="wrap-icon-sidebar" title={isCollapse ? 'Báo cáo-Thống kê' : null}>
                        {isCollapse ? <Icon style={{ fontSize: '18px' }} type="bar-chart" />
                          : <><Icon type="bar-chart" />Báo cáo - Thống kê </>}
                      </span>
                    )}
                  >
                    <SubMenu
                      key="thong-ke/thong-tu-01"
                      className="QTI-submenu-thong-ke"
                      title="Thông tư 01"
                    >
                      <MenuItem key="thong-ke/tong-hop-dau-ra" className="QTI-menu-sidebar-wrap">
                        <Link
                          title="Tổng hợp đầu ra"
                          to="/thong-ke/tong-hop-dau-ra"
                        >
                          <Icon type="bar-chart" />Tổng hợp đầu ra
                        </Link>
                      </MenuItem>
                      {!isCapXa && (
                        <Menu.Item key="thong-ke/bieu2085" className="QTI-menu-sidebar-wrap">
                          <Link
                            title="Kết quả thực hiện các chính sách đất ở, đất sản xuất và nước sinh hoạt phân tán,
                          đinh canh định cư theo quyết định số 2085/QĐ-TTG (huyện bc)"
                            to="/thong-ke/bieu2085"
                          >
                            <Icon type="bar-chart" />Biểu số 006/ĐP/2085
                          </Link>
                        </Menu.Item>
                      )}
                      {!isCapXa && (
                        <Menu.Item key="thong-ke/bieu135" className="QTI-menu-sidebar-wrap">
                          <Link
                            title="Kết quả thực hiện dự án đầu tư CSHT chương trình 135 (huyện bc)"
                            to="/thong-ke/bieu135"
                          >
                            <Icon type="bar-chart" />Biểu số 002B/ĐP/135.CSHT
                          </Link>
                        </Menu.Item>
                      )}
                      {!isCapXa && (
                        <Menu.Item key="thong-ke/bieu-tong-hop-so-008DP1163" className="QTI-menu-sidebar-wrap">
                          <Link
                            // eslint-disable-next-line max-len
                            title="Kết quả thực hiện đề án “Đẩy mạnh công tác phổ biến, giáo dục và tuyên truyền, đồng bào
                           vùng DTTS&MN giai đoạn 2017 – 2021” theo quyết định số 1163/QĐ-TTG (huyện bc)"
                            to="/thong-ke/bieu-tong-hop-so-008DP1163"
                          >
                            <Icon type="bar-chart" />Biểu số 008/ĐP/1163
                          </Link>
                        </Menu.Item>
                      )}
                      {!isCapXa && (
                        <Menu.Item key="thong-ke/bieu-tong-hop-so-010DP498" className="QTI-menu-sidebar-wrap">
                          <Link
                            title="Kết quả thực hiện đề án “Giảm thiểu tình trạng tảo hôn và hôn nhân cận huyến thống
                         trong vùng dân tộc thiểu số giai đoạn 2015 – 2025” theo quyết định số 498/QĐ-TTG (huyện bc)"
                            to="/thong-ke/bieu-tong-hop-so-010DP498"
                          >
                            <Icon type="bar-chart" />Biểu số 010/ĐP/498
                          </Link>
                        </Menu.Item>
                      )}
                      {!isCapXa && (
                        <Menu.Item
                          key="thong-ke/bieu-tong-hop-so-012DP2214"
                          className="QTI-menu-sidebar-wrap"
                        >
                          <Link
                            // eslint-disable-next-line max-len
                            title="Kết quả thực hiện đề án tăng cường hợp tác quốc tế hỗ trợ phtas triển kinh tế - xã hội vùng đồng bào DTTS theo quyết định số 2214/QĐ-TTG của thủ tướng chính phủ (huyện bc)"
                            to="/thong-ke/bieu-tong-hop-so-012DP2214"
                          ><Icon type="bar-chart" />Biểu số 12/ĐP/2214
                          </Link>
                        </Menu.Item>
                      )}
                      {!isCapXa && (
                        <Menu.Item
                          key="thong-ke/so-011-dp-1898"
                          className="QTI-menu-sidebar-wrap"
                        >
                          <Link
                            // eslint-disable-next-line max-len
                            title="Kết quả thực hiện đề án'Hỗ trợ hoạt động bình đẳng giới vùng DTTS giai đoạn 2018-2025' theo quyết định số 1898/QĐ_TTG (huyện bc)"
                            to="/thong-ke/so-011-dp-1898"
                          ><Icon type="bar-chart" />Biểu số 011/ĐP/1898
                          </Link>
                        </Menu.Item>
                      )}
                      {!isCapXa && (
                        <Menu.Item
                          key="thong-ke/bieu-tong-hop-so-07-dp-12"
                          className="QTI-menu-sidebar-wrap"
                        >
                          <Link
                            // eslint-disable-next-line max-len
                            title="Kết quả thực hiện chính sách đối với người có uy tín theo quyết định số 12/2018/QĐ-TTg (huyện bc)"
                            to="/thong-ke/bieu-tong-hop-so-07-dp-12"
                          ><Icon type="bar-chart" />Biểu số 07/ĐP/12
                          </Link>
                        </Menu.Item>
                      )}
                      {!isCapXa && (
                        <Menu.Item
                          key="thong-ke/ket-qua-thuc-hien-cong-tac-dan-toc"
                          className="QTI-menu-sidebar-wrap"
                          style={{ whiteSpace: 'normal' }}
                        >
                          <Link
                            title="Kết quả thực hiện công tác dân tộc (huyện bc)"
                            to="/thong-ke/ket-qua-thuc-hien-cong-tac-dan-toc"
                          >
                            <Icon type="bar-chart" />Biểu KQ thực hiện công tác dân tộc
                          </Link>
                        </Menu.Item>
                      )}
                    </SubMenu>
                    {!isCapXa && (
                      <SubMenu
                        key="thong-ke/thong-tu-02"
                        className="QTI-submenu-thong-ke"
                        title="Thông tư 02"
                      >
                        {isTKCapTinh && (
                          <Menu.Item
                            key="thong-ke/bieu-01-sgddt"
                            className="QTI-menu-sidebar-wrap"
                          >
                            <Link
                              title="Tổng hợp số trường, lớp, giáo viên, học sinh giáo dục phổ thông (bdt bc)"
                              to="/thong-ke/bieu-01-sgddt"
                            ><Icon type="bar-chart" />Biểu số 01.N/BC-SGD&ĐT
                            </Link>
                          </Menu.Item>
                        )}
                        {/* <Menu.Item
                        key="thong-ke/bieu-02-sgddt"
                        className="QTI-menu-sidebar-wrap"
                      >
                        <Link
                          title="Học sinh dân tộc thiểu số đi học đúng độ tuổi"
                          to="/thong-ke/bieu-02-sgddt"
                        ><Icon type="bar-chart" />Biểu số 02.N/BC-SGD&ĐT
                        </Link>
                      </Menu.Item> */}
                        {isTKCapTinh && (
                          <Menu.Item
                            key="thong-ke/bieu-03-sgddt"
                            className="QTI-menu-sidebar-wrap"
                          >
                            <Link
                              title="Số học sinh người dân tộc thiểu số bỏ học, lưu ban (bdt bc)"
                              to="/thong-ke/bieu-03-sgddt"
                            ><Icon type="bar-chart" />Biểu số 03.N/BC-SGD&ĐT
                            </Link>
                          </Menu.Item>
                        )}
                        {/* <Menu.Item
                        key="thong-ke/bieu-04-sgtvt"
                        className="QTI-menu-sidebar-wrap"
                      >
                        <Link
                          // eslint-disable-next-line max-len
                          title="Số lượng, tỷ lệ các thôn bản vùng dân tộc thiểu số đã có đường giao thông được đầu tư nâng cấp, cải tạo, xây dựng mới"
                          to="/thong-ke/bieu-04-sgtvt"
                        ><Icon type="bar-chart" />Biểu số 04.N/BC-SGTVT
                        </Link>
                      </Menu.Item>
                      <Menu.Item
                        key="thong-ke/bieu-05-sldtbxh"
                        className="QTI-menu-sidebar-wrap"
                      >
                        <Link
                          title="Hộ nghèo và cận nghèo người dân tộc thiểu số"
                          to="/thong-ke/bieu-05-sldtbxh"
                        ><Icon type="bar-chart" />Biểu số 05.N/BC-SLĐ-TB&XH
                        </Link>
                      </Menu.Item> */}
                        {isTKCapTinh && (
                          <Menu.Item
                            key="thong-ke/bieu-06-snv"
                            className="QTI-menu-sidebar-wrap"
                          >
                            <Link
                              title="Số lượng đại biểu hội đồng nhân dân các cấp là người dân tộc thiểu số (bdt bc)"
                              to="/thong-ke/bieu-06-snv"
                            ><Icon type="bar-chart" />Biểu số 06.K/BC- SNV
                            </Link>
                          </Menu.Item>
                        )}
                        <Menu.Item
                          key="thong-ke/bieu-07-bdt"
                          className="QTI-menu-sidebar-wrap"
                        >
                          <Link
                            title="Số lượng công chức trong các cơ quan công tác dân tộc các cấp ( huyện và bdt bc)"
                            to="/thong-ke/bieu-07-bdt"
                          ><Icon type="bar-chart" />Biểu số 07.N/BC-BDT
                          </Link>
                        </Menu.Item>
                        <Menu.Item
                          key="thong-ke/bieu-09-ubdt"
                          className="QTI-menu-sidebar-wrap"
                        >
                          <Link
                            // eslint-disable-next-line max-len
                            title="Số công chức, viên chức trong cơ quan công tác dân tộc các cấp được đào tạo, bồi dưỡng về công tác dân tộc, lý luận chính trị, quản lý nhà nước và đào tạo khác (huyện và bdt bc)"
                            to="/thong-ke/bieu-09-ubdt"
                          ><Icon type="bar-chart" />Biểu số 09.N/BC-UBDT
                          </Link>
                        </Menu.Item>
                        {/* <Menu.Item
                        key="thong-ke/bieu-sx135"
                        className="QTI-menu-sidebar-wrap"
                      >
                        <Link
                          title="Kết quả thực hiện dự án hổ trợ phát triển sản xuất chương trình 135"
                          to="/thong-ke/bieu-sx135"
                        ><Icon type="bar-chart" />Biểu tổng hợp số 003/ĐP/135.PTSX
                        </Link>
                      </Menu.Item> */}
                      </SubMenu>
                    )}
                  </SubMenu>
                )}
            </Menu>
          </CustomScrollbars>
        </div>
      </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {
  auth: PropTypes.objectOf(PropTypes.any).isRequired,
  themeType: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  navStyle: PropTypes.string.isRequired,
  activedVaiTro: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ settings, auth }) => {
  const {
    navStyle, themeType, locale, pathname
  } = settings;
  return {
    navStyle, themeType, locale, pathname, auth
  };
};
export default connect(mapStateToProps)(SidebarContent);
